<template>
    <div class="resource-panel">
        <div class="resource-list">
            <div class="notification" v-if="!isSurveysEmpty">
                <div class="resource-header">
                    <img src="../assets/icons/poll.svg">
                    {{$t('str.Surveys')}}
                </div>
                <div>
                    <ul>
                        <li class="resources" >
                            <div>
                                <img src="../assets/icons/unchecked.svg">
                                <a class="survey item" v-for="(survey, index) in surveys" v-bind:key="index" v-on:click="launchSurvey(survey)">{{survey.title}}</a>
                                <p class="resource-info">({{$t('str.TakeTheSurvey')}})</p>                                
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="notification" v-if="showFiles">
                <div class="resource-header">
                    <img class="file" src="../assets/icons/attach-file.svg">
                    <span>{{$t('str.Files')}}</span>
                </div>
                <div>
                    <ul>
                        <li class="resources" v-for="(file, index) in presentation.props.Resources[slideNum].Files" v-bind:key="index">
                            <div>
                                <img src="../assets/icons/download-red.svg">
                                <a class="item" v-on:click="openFile(file.label)">
                                    {{file.label}}
                                    <p class="resource-info">({{file.size/1000}} {{$t('str.KB')}})</p>
                                </a>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="notification" v-if="showLinks">
                <div class="resource-header">
                    <img src="../assets/icons/link.svg">
                    <span>{{$t('str.Links')}}</span>
                </div>
                <div>
                    <ul>
                        <li class="resources" v-for="(link, index) in presentation.props.Resources[slideNum].Links" v-bind:key="index">
                            <img class="link" src="../assets/icons/link-red.svg">
                            <a class="item" v-bind:href="link.data" target="_blank" v-on:click="recordLead('link', link.label, link.data)">
                                {{link.label}}
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="notification" v-if="showNotes">
                <div class="resource-header">
                    <img src="../assets/icons/speaker-notes.svg">
                    <span>{{$t('str.SpeakerNotes')}}</span>
                </div>
                <div>
                    <ul>
                        <li class="resources" v-for="(note, index) in presentation.props.Resources[slideNum].Notes" v-bind:key="index">
                            <div class="notes-display">
                                <a class="note-label">{{note.label}}</a>
                                <p class="note-content">{{note.data}}</p>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="resource-panel-close">
            <a v-on:click="close">
                <i class="fa fa-times"></i>
            </a>
        </div>
    </div>
</template>
<script>

import {EventBus, LeadBus} from '../router/index';

export default {
    props: {
        presentation: {},
        user: {},
        slideList: {},
        currentSlide: '',
        surveys: {}
    },

    data() {
        return {
            slideNum: this.slideList[this.currentSlide].slideId
        };
    },

    computed: {
        showFiles() {
            return this.presentation.props.Resources && this.presentation.props.Resources[this.slideNum] && this.presentation.props.Resources[this.slideNum].Files && this.presentation.props.Resources[this.slideNum].Files.length !== 0;
        }, 

        showLinks() {
            return this.presentation.props.Resources && this.presentation.props.Resources[this.slideNum] && this.presentation.props.Resources[this.slideNum].Links && this.presentation.props.Resources[this.slideNum].Links.length !== 0;
        },

        showNotes() {
            return this.presentation.props.Resources && this.presentation.props.Resources[this.slideNum] && this.presentation.props.Resources[this.slideNum].Notes && this.presentation.props.Resources[this.slideNum].Notes.length !== 0;
        },

        isSurveysEmpty() {
            return this.surveys ? !this.surveys.length : true;
        }
    },

    watch: {
        currentSlide() {
            this.slideNum = this.slideList[this.currentSlide].slideId;
        }
    },

    methods: {
        launchSurvey(survey) {
            EventBus.$emit('startSurvey', survey, (json) => {
                EventBus.$emit('submitSurvey', JSON.stringify(json));
            }, console.log, () => {
                console.log('Survey cancelled');
            });
        },

        openFile(fileName) {
            var fileLink = `https://res.dialogloop.com/${this.presentation.id}/${fileName}`;
            window.open(fileLink);
            this.recordLead('file', fileName, fileLink);
        },

        close() {
            this.$emit('closeResources');
        },

        recordLead(type, label, link) {
            if (type === 'file') {
                LeadBus.$emit('recordLead', {type: 'resource-file', data: {label: label, link: link}});
            } else if (type === 'link') {
                LeadBus.$emit('recordLead', {type: 'resource-link', data: {label: label, link: link}});
            }
        }
    }
};

</script>

<style lang="scss">

.resource-info {
    font-size: 75%;
    color: #777;
    display: inline-block;
}

::-webkit-scrollbar {
  width: 5px;
  background-color: #242424;
  border-right: 2px solid rgba(255, 255, 255, 0.35);
  border-top: 2px solid rgba(255, 255, 255, 0.50); 
}

::-webkit-scrollbar-thumb {
  border-radius: 0;
  background: #fff;
}

::-webkit-scrollbar-thumb:window-inactive {
  background: #fff;
}

.resource-panel {
    @media screen and (max-width: 450px) {
        width: 100%;
    }
    @media screen and (min-width: 450px) {
        min-width: 400px;
        max-width: 30vw;
        float: left;
    }
  
    display: block;
    overflow-y: auto;
    position: absolute;
    right: 0px;
    margin-right: 25px;
    margin-left: 50px;
    bottom: 60px;
    max-height: 35vh;
    color: #fff;
    font-size: 15px;
    line-height: 1.5;
    font-family: "Poppins", "Helvetica Neue", Helvetica, Arial, sans-serif;

    img {
        width: 20px;
        vertical-align: middle;
    }

    .resource-list {
        border-left: 2px solid rgba(255, 255, 255, 0.35); 
        border-top: 2px solid rgba(255, 255, 255, 0.50);  
        min-height: 100%;
        max-height: 800px;
        min-width: 80%;
        position: relative;
        margin-left: 50px;
        background-color: #242424;

        .notification {
            position: relative;
            max-height: 100%;
            padding: 2px 3px 2px 3px;
            border-radius: 0px;
            background-color: #242424;


            .resource-header {
                margin-bottom: 0px;
                font-family: 'Poppins', sans-serif;
                font-size: 0.9em;
                width: 100%;
                display: inline-block;
                background-color: #333;
                padding: 0px;
                border-top-left-radius: 0px;
                border-top-right-radius: 0px;
                
                .file {
                    transform: rotate(90deg);
                }
            }

            div {
                ul {
                    padding: 0 0px 5px 0px;
                    border-radius: 3px;
                    margin: 0px;
                    list-style-type: none;

                    .resources {
                        div {
                            .survey {
                                color: #8dc63f;
                                text-decoration: none;
                                background-color: transparent;
                            }
                        }

                        .item {
                            margin: 5px;
                            color: #d4451d;
                            text-decoration: none;
                            background-color: transparent;
                            font-size: 90%;
                            cursor: pointer;
                        }

                        .notes-display {
                            margin-left: 30px;

                        .note-content {
                            font-size: 90%;
                        }
                            
                            .note-label {
                                font-size: 90%;
                                font-weight: bold;
                        }

                            .note-content {
                                font-size: 90%;
                            }
                        }                        
                    }
                }
            }    
        }
    }

    .resource-panel-close {
        position: absolute;
        top: 0;
        right: 10px;

        a {
            text-decoration: none;
            font-size: 20px;
        }
    }
}

</style>


// WEBPACK FOOTER //
// ResourcesTray.vue?6c781f2e